import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { ChartModule } from 'primeng/chart';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ProgressBarModule } from 'primeng/progressbar';
import { DialogModule } from 'primeng/dialog';
import { ToolbarModule } from 'primeng/toolbar';
import { OrderListModule } from 'primeng/orderlist';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NgModule } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { ToastModule } from 'primeng/toast';
import { BadgeModule } from 'primeng/badge';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SpeedDialModule } from 'primeng/speeddial';
import { FieldsetModule } from 'primeng/fieldset';
import { ImageModule } from 'primeng/image';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { PickListModule } from 'primeng/picklist';
import { DragDropModule } from 'primeng/dragdrop';
import { ColorPickerModule } from 'primeng/colorpicker';
import { EditorModule } from 'primeng/editor';
import { AnimateModule } from 'primeng/animate';
import { AutoFocusModule } from 'primeng/autofocus';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
  imports: [
    CardModule,
    SplitButtonModule,
    AutoFocusModule,
    EditorModule,
    DragDropModule,
    ColorPickerModule,
    PickListModule,
    ImageModule,
    MessagesModule,
    MessageModule,
    RadioButtonModule,
    AnimateModule,
    FieldsetModule,
    SpeedDialModule,
    InputTextareaModule,
    SkeletonModule,
    BadgeModule,
    ToggleButtonModule,
    ToastModule,
    DividerModule,
    PasswordModule,
    ButtonModule,
    OverlayPanelModule,
    PanelModule,
    SidebarModule,
    ToolbarModule,
    ConfirmDialogModule,
    OrderListModule,
    DialogModule,
    ProgressBarModule,
    CalendarModule,
    InputNumberModule,
    InputSwitchModule,
    InputTextModule,
    RippleModule,
    TableModule,
    DropdownModule,
    CheckboxModule,
    TooltipModule,
    ChartModule,
    FileUploadModule
  ],
  declarations: [],
  exports: [
    ToastModule,
    BadgeModule,
    InputTextModule,
    FieldsetModule,
    ToggleButtonModule,
    ConfirmDialogModule,
    AnimateModule,
    EditorModule,
    SpeedDialModule,
    TableModule,
    DialogModule,
    CalendarModule,
    MessagesModule,
    AutoFocusModule,
    SplitButtonModule,
    MessageModule,
    RadioButtonModule,
    PasswordModule,
    SidebarModule,
    ToolbarModule,
    SkeletonModule,
    OrderListModule,
    DividerModule,
    PanelModule,
    ButtonModule,
    OverlayPanelModule,
    PickListModule,
    TooltipModule,
    ImageModule,
    ColorPickerModule,
    ProgressBarModule,
    DragDropModule,
    InputSwitchModule,
    CheckboxModule,
    ChartModule,
    CardModule,
    DropdownModule,
    FileUploadModule,
    RippleModule,
    InputTextareaModule,
  ],
})
export class PrimeNGModule { }

